import styled from 'styled-components'
import loginBg from '@/assets/imges/login-bg2.png'
import { useGetLogo } from '../login/util'
import { useEffect, useMemo } from 'react'
import { t } from '@/i18n'
const bgLoad: React.ReactEventHandler<HTMLImageElement> = e => ((e.target as any).style.opacity = 1)
const Outdated = () => {
  const [getLogo, logo] = useGetLogo()
  useEffect(() => {
    getLogo().catch(_ => {})
  }, [])
  const Logo = useMemo(() => {
    let img = ''
    let fileType = ''
    if (logo?.login_logo_file_path?.file_name) {
      fileType = logo.login_logo_file_path.file_name.substring(
        logo.login_logo_file_path.file_name.lastIndexOf('.') + 1,
      )
      switch (fileType) {
        case 'png':
          img = `data:image/png;base64,${logo?.login_logo_file_path.base64}`
          break
        case 'jpg' || 'jpeg':
          img = `	data:image/jpeg;base64,${logo?.login_logo_file_path.base64}`
          break
        case 'gif':
          img = `data:image/gif;base64,${logo?.login_logo_file_path.base64}`
          break
        case 'svg':
          img = `data:image/svg+xml;base64,${logo?.login_logo_file_path.base64}`
          break
        case 'ico':
          img = `data:image/x-icon;base64,${logo?.login_logo_file_path.base64}`
          break
        case 'bmp':
          img = `data:image/bmp;base64,${logo?.login_logo_file_path.base64}`
          break
        default:
          break
      }
    }
    return img
  }, [logo])
  return (
    <Content className="background-image">
      <BgImg src={loginBg} onLoad={bgLoad}>
        {Logo !== '' && <img className="logo" alt="..." width={190} src={Logo} />}
        {logo?.on_off === 1 && (
          <p className="copyright">
            {logo?.copyright} {t('版权所有')}
          </p>
        )}
      </BgImg>
      <div className="content">
        <img
          src="https://th.bing.com/th?id=OIP.8YXr4APqt5nDd1MhX-S5pwAAAA&w=187&h=333&c=8&rs=1&qlt=90&o=6&dpr=2&pid=3.1&rm=2"
          alt=""
          width={184}
          height={132}
        />

        <div style={{ fontWeight: 500, fontSize: 30, color: '#2090A8', margin: '60px 0 34px 0' }}>
          {t('您的设备授权已过期')}
        </div>
        <div style={{ color: '#333', fontSize: 20 }}>{t('如想继续使用服务，请联系商务续期')}</div>
      </div>
    </Content>
  )
}
export default Outdated
const Content = styled.div`
  .content {
    position: absolute;
    right: 0px;
    z-index: 1;
    height: 100%;
    width: 42%;
    background-color: #fff;
    border-radius: 24px 0px 0px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* padding-top: 220px; */
  }
  position: relative;
  height: 100%;
  display: flex;
  background: #dde1ff;
  .logo {
    position: absolute;
    display: inline-block;
    width: 190px;
    height: 52px;
    z-index: 99;
    margin: 34px 37px;
    object-fit: cover;
  }
  .copyright {
    position: absolute;
    bottom: 50px;
    font-size: 12px;
    color: #666666;
    line-height: 18px;
    word-break: break-all;
    word-wrap: break-word;
    width: 97%;
    text-align: center;
  }
`
const BgImg = styled.div`
  position: relative;
  align-items: flex-end;
  flex: 0.6;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  background-image: url(${loginBg});
`
